import { render, staticRenderFns } from "./setSalary.vue?vue&type=template&id=85f30002&scoped=true&"
import script from "./setSalary.vue?vue&type=script&lang=js&"
export * from "./setSalary.vue?vue&type=script&lang=js&"
import style0 from "./setSalary.vue?vue&type=style&index=0&id=85f30002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f30002",
  null
  
)

export default component.exports